<div class="ec-notifications-container" *appVar="entity|async as entity">
    <ng-container *ngIf="!entity || isReadable(entity); else unreadableEntity">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="notification-bar">
            <button *ngIf="!entity" app-ghost-button
                    (click)="onClickGotoDashboard()">
                <app-icon name="fal-arrow-left"></app-icon>
                {{'Back to dashboard'|i18n}}
            </button>
            <div fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="10px" class="mr-24">
                <span class="title"> {{'Period'|i18n}}{{":"}} </span>
                <div fxLayout="row" fxLayoutAlign="start center">
                    <app-time-filter [profile]="TimeFilterProfile.NOTIFICATION"
                                     (timeFilterChange)="onSelectTimeFilter($event)">
                    </app-time-filter>
                </div>
            </div>
        </div>
        <ng-container *appVar="pagedNotifications|async as pagedNotifications">
            <div class="notifications-body" fxLayout="column" fxLayoutGap="15px" fxLayoutAlign="center center">
                <div *ngIf="pagedNotifications; else loadingNotifications"
                     fxLayout="column" class="notifications-body-container" >
                    <div *ngIf="pagedNotifications.total === 0" fxLayoutAlign="center" class="pt-16">
                        {{'No notifications found'|i18n}}
                    </div>
                    <div fxLayout="row">
                        <mat-accordion class="notifications" >
                            <mat-expansion-panel *ngFor="let n of pagedNotifications.data"
                                                 [ngClass]="{'no-details': !knownStatus(n.not.status)}"
                                                 [hideToggle]="!knownStatus(n.not.status)"
                                                 [expanded]="selectedNotification === n"
                                                 (afterExpand)="onOpenNotificationPanel(n)"
                                                 (closed)="onCloseNotificationPanel()" >
                                <mat-expansion-panel-header *appVar="n.not as not" >
                                    <mat-panel-title >
                                        <div fxLayout="row"  class="notification" fxLayoutAlign="space-between center" fxLayoutGap="20px">
                                            <div fxLayoutGap="20px">
                                                <app-icon class="notification-icon"
                                                          name='fal-exclamation-circle'></app-icon>
                                                <span class="notification-status">{{not.status|notStatus|i18n}}</span>
                                            </div>
                                            <span class=" notification-time">{{not.timestamp|i18nTimestamp}}</span>
                                        </div>
                                    </mat-panel-title>
                                </mat-expansion-panel-header>
                                <div *ngIf="!knownStatus(n.not.status)" fxLayoutAlign="center">
                                    <p>{{'No details available'|i18n}}</p>
                                </div>
                                <div *ngIf="n.not.status === STATUSES.EC_MISSING_CONSUMPTION_ADVICE"
                                     fxLayout="column"
                                     fxLayoutAlign="center space-between" fxLayoutGap="30px" class="mt-20">
                                    <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px">
                                        <span>{{'Due to lack of weather data, the daily consumption advice could not be sent to members.'|i18n}}</span>
                                        <span>{{'Check for weather data on the “Weather Forecast” page and contact support if it is missing.'|i18n}}</span>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="center center">
                                        <button  app-ghost-button
                                                 (click)="onClickGotoSection(n.not.status)">
                                            {{'Go to the section'|i18n}}
                                            <app-icon name="fal-arrow-right" class="ml-5"></app-icon>
                                        </button>
                                    </div>
                                </div>
                                <div *ngIf="n.not.status === STATUSES.EC_STATISTICS_FAIL"
                                     fxLayout="column"
                                     fxLayoutAlign="center space-between" fxLayoutGap="30px" class="mt-20">
                                    <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px">
                                        <span>{{'It was not possible to obtain an estimate of measurements for the period'|i18n}} <b>{{ ' {0} - {1} '|i18n: getTomorrowDates(n.not.timestamp) : getTomorrowDates(n.not.timestamp, true)}} </b> {{'and therefore the data are not available in mobile app.'|i18n}}</span>
                                        <span>{{'Verify that the community is active and that there are active members and that the statistical profiles of resources are correctly filled out.'|i18n}}</span>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="center center">
                                        <button  app-ghost-button
                                                 (click)="onClickGotoSection(n.not.status)">
                                            {{'Go to the section'|i18n}}
                                            <app-icon name="fal-arrow-right" class="ml-5"></app-icon>
                                        </button>
                                    </div>
                                </div>
                                <div *ngIf="n.not.status === STATUSES.EC_WEEKLY_PERFORMANCE_FAIL"
                                     fxLayout="column"
                                     fxLayoutAlign="center space-between" fxLayoutGap="30px" class="mt-20">
                                    <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px">
                                        <span>{{'Due to missing measurements or insufficient statistical data, we could not compute performance for the week'|i18n}} <b>{{ ' {0} - {1} '|i18n: getWeekDates(n.not.timestamp) : getWeekDates(n.not.timestamp, true)}} </b> </span>
                                        <span>{{'Contact support for assistance.'|i18n}}</span>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="center center" *ngIf="customerCareEnabled|async">
                                        <button  app-ghost-button
                                                 (click)="onClickGotoSection(n.not.status)">
                                            {{'Go to the section'|i18n}}
                                            <app-icon name="fal-arrow-right" class="ml-5"></app-icon>
                                        </button>
                                    </div>
                                </div>
                                <div *ngIf="n.not.status === STATUSES.EC_CONSUMPTION_ADVICE_SEND_FAIL"
                                     fxLayout="column"
                                     fxLayoutAlign="center space-between" fxLayoutGap="30px" class="mt-20">
                                    <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px">
                                        <span>{{'Push notification with daily consumption advice could not be sent to members in mobile app.'|i18n}}</span>
                                        <span>{{'Contact support for assistance.'|i18n}}</span>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="center center" *ngIf="customerCareEnabled|async">
                                        <button  app-ghost-button
                                                 (click)="onClickGotoSection(n.not.status)">
                                            {{'Go to the section'|i18n}}
                                            <app-icon name="fal-arrow-right" class="ml-5"></app-icon>
                                        </button>
                                    </div>
                                </div>
                                <div *ngIf="n.not.status === STATUSES.EC_WEEKLY_PERFORMANCE_SEND_FAIL"
                                     fxLayout="column"
                                     fxLayoutAlign="center space-between" fxLayoutGap="30px" class="mt-20">
                                    <div fxLayout="column" fxLayoutAlign="center start" fxLayoutGap="5px">
                                        <span>{{'Could not send push notification with the performance for the week'|i18n}} <b>{{ ' {0} - {1} '|i18n: getWeekDates(n.not.timestamp) : getWeekDates(n.not.timestamp, true)}} </b> {{'to the app members.'|i18n}}</span>
                                        <span>{{'Contact support for assistance.'|i18n}}</span>
                                    </div>
                                    <div fxLayout="row" fxLayoutAlign="center center" *ngIf="customerCareEnabled|async">
                                        <button  app-ghost-button
                                                 (click)="onClickGotoSection(n.not.status)">
                                            {{'Go to the section'|i18n}}
                                            <app-icon name="fal-arrow-right" class="ml-5"></app-icon>
                                        </button>
                                    </div>
                                </div>
                            </mat-expansion-panel>
                        </mat-accordion>
                    </div>
                </div>
                <mat-paginator #paginator class="notifications-paginator"
                               [ngClass]="{'collapsed': !pagedNotifications || pagedNotifications.total === 0}"
                               [length]="pagedNotifications?.total" [pageSize]="PAGE_SIZE"
                               [pageSizeOptions]="PAGE_SIZES">
                </mat-paginator>
            </div>
        </ng-container>
    </ng-container>
</div>

<ng-template #loadingNotifications>
    <div fxLayout="column">
        <div fxLayout="row inline" fxFlexAlign="center" class="mt-24 mb-16">
            <mat-spinner diameter="20"></mat-spinner>
            <span class="pl-8">{{'Loading notifications'|i18n}}...</span>
        </div>
    </div>
</ng-template>

<ng-template #unreadableEntity>
    <div fxLayout="row" fxLayoutAlign="center">
        {{'Insufficient permissions to view notifications'|i18n}}
    </div>
</ng-template>
